import { render, staticRenderFns } from "./smartFarming.vue?vue&type=template&id=5b89e17f&scoped=true&"
import script from "./smartFarming.vue?vue&type=script&lang=js&"
export * from "./smartFarming.vue?vue&type=script&lang=js&"
import style0 from "./smartFarming.vue?vue&type=style&index=0&id=5b89e17f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89e17f",
  null
  
)

export default component.exports